"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DeliveryOptionsTypeToI18NKey = void 0;
exports.DeliveryOptionsTypeToI18NKey = {
    101: 'Delivery_option_item_Download',
    102: 'Delivery_option_item_SendByEmail',
    103: 'Delivery_option_item_CreateSharedLink',
    105: 'Delivery_option_item_SaveToPersonal',
    106: 'Delivery_option_item_SendToLiveShare',
    107: 'Delivery_option_item_SendToCart',
    108: 'Delivery_option_item_SendToLiveSend',
    109: 'Delivery_option_item_SendToGmail',
    113: 'Delivery_option_item_GenerateLiveSendLink',
    111: 'Delivery_option_item_SendToSalesforce',
    112: 'Delivery_option_item_SendToSharePoint',
    131: 'Delivery_option_item_SFSendByEmail',
    132: 'Delivery_option_item_SFPostToChatter',
    133: 'Delivery_option_item_SFSaveAttachment',
    134: 'Delivery_option_item_SFCreateContent',
    135: 'Delivery_option_item_SFCreateContentDelivery',
    220: 'Delivery_option_item_CopyToUserDrive',
    54: 'Delivery_option_item_OnLineEdit',
    143: 'Delivery_option_item_Print',
    144: 'Delivery_option_item_ShareWithGood',
    141: 'Delivery_option_item_SendByEmail',
    114: 'Delivery_option_item_SendByEmailBlast',
    115: 'Delivery_option_item_CreatePrintOrder',
    116: 'Delivery_option_item_SendBySocial',
    117: 'Delivery_option_item_SendBySMS',
};
//# sourceMappingURL=DeliveryOptionsTypeToI18NKey.js.map